<template>
  <div v-if="value" class="live-modal-overlay" @click.self="close">
    <div class="live-modal">
      <!-- KPI Bar -->
      <div class="live-modal__kpi-bar">
        <div class="live-modal__kpi-item">
          <img src="../../static/image/meteo/temperatura.svg" width="50" height="50" alt=""/>
          <div class="live-modal__kpi-data">
            <span class="live-modal__kpi-value">{{ meteo.temperatura }}</span>
            <span class="live-modal__kpi-name">{{ $t("temperature") }}</span>
          </div>
        </div>
        <div class="live-modal__kpi-item">
          <img src="../../static/image/meteo/umidita.svg" width="50" height="50" alt=""/>
          <div class="live-modal__kpi-data">
            <span class="live-modal__kpi-value">{{ meteo.umidita }}</span>
            <span class="live-modal__kpi-name">{{ $t("humidity") }}</span>
          </div>
        </div>
        <div class="live-modal__kpi-item">
          <img src="../../static/image/meteo/vento.svg" width="50" height="50" alt=""/>
          <div class="live-modal__kpi-data">
            <span class="live-modal__kpi-value">{{ meteo.vento }}</span>
            <span class="live-modal__kpi-name">{{ $t("wind") }}</span>
          </div>
        </div>
        <div class="live-modal__kpi-item">
          <img src="../../static/image/meteo/pioggia.svg" width="50" height="50" alt=""/>
          <div class="live-modal__kpi-data">
            <span class="live-modal__kpi-value">{{ meteo.pioggia }}</span>
            <span class="live-modal__kpi-name">{{ $t("rain") }}</span>
          </div>
        </div>
      </div>

      <!-- Close button -->
      <div class="live-modal__header">
        <div></div>
        <div class="live-modal__header-right">
          <button class="live-modal__close" aria-label="Close" @click="close">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5 3.5L3.5 12.5M3.5 3.5L12.5 12.5" stroke="white" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
      </div>

      <!-- Iframe video -->
      <div class="live-modal__iframe-container">
        <iframe
          class="live-modal__video"
          src="https://stream-meteoproject.eu/weathercam-player.php?code=90"
          frameborder="0"
          allowfullscreen
          scrolling="no"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LiveMeteoModal',
    props: {
      value: { type: Boolean, default: false }
    },
    i18n: {
      fallbackLocale: 'it',
      messages: {
        it: {
          temperature: 'Temperatura',
          humidity: 'Umidità',
          wind: 'Vento',
          rain: 'Pioggia'
        },
        en: {
          temperature: 'Temperature',
          humidity: 'Humidity',
          wind: 'Wind',
          rain: 'Rain'
        }
      }
    },
    data() {
      return {
        meteo: {
          temperatura: '--',
          umidita: '--',
          vento: '--',
          pioggia: '--'
        }
      }
    },
    watch: {
      value(open) {
        if (open) this.fetchMeteo()
      }
    },
    methods: {
      close() {
        this.$emit('input', false)
      },
      fetchMeteo() {
        var url = 'https://api.ecowitt.net/api/v3/device/real_time'
        var params = new URLSearchParams({
          application_key: '26AAE9A9658B0500740B5D59C01DD5BC',
          api_key: 'e2b40613-d91a-42cf-9b6c-d58541eb4095',
          mac: 'E4:B0:63:17:8D:FC',
          call_back: 'outdoor,wind,rainfall',
          temp_unitid: '1',
          wind_speed_unitid: '7',
          rainfall_unitid: '12'
        })
        var controller = new AbortController()
        var timer = setTimeout(function () { controller.abort() }, 8000)
        var self = this
        fetch(url + '?' + params, { signal: controller.signal })
          .then(function (res) {
            clearTimeout(timer)
            if (!res.ok) throw new Error(res.status)
            return res.json()
          })
          .then(function (json) {
            if (json.code !== 0) throw new Error(json.msg)
            var data = json.data
            self.meteo.temperatura = ((data.outdoor && data.outdoor.temperature ? data.outdoor.temperature.value : '--')) + ' °C'
            self.meteo.umidita = ((data.outdoor && data.outdoor.humidity ? data.outdoor.humidity.value : '--')) + ' %'
            self.meteo.vento = ((data.wind && data.wind.wind_speed ? data.wind.wind_speed.value : '--')) + ' km/h'
            self.meteo.pioggia = ((data.rainfall && data.rainfall.rain_rate ? data.rainfall.rain_rate.value : '--')) + ' mm/h'
          })
          .catch(function (err) {
            clearTimeout(timer)
            console.warn('Meteo: errore fetch Ecowitt', err)
          })
      }
    }
  }
</script>

<style lang="less" scoped>
  .live-modal-overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 13000;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.7);
  }

  .live-modal {
    position: relative;
    width: 85%;
    max-width: 1400px;
    border-radius: 12px;
    overflow: hidden;
    background: #000;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);

    &__kpi-bar {
      position: absolute;
      top: 16px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10;
      display: flex;
      align-items: center;
      gap: 60px;
      background: rgba(255, 255, 255, 0.2);
      backdrop-filter: blur(8px);
      border-radius: 12px;
      padding: 28px 72px;
    }

    &__kpi-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
    }

    &__kpi-data {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2px;
      line-height: 1.2;
    }

    &__kpi-value {
      font-size: 20px;
      font-weight: 700;
      color: #000;
      text-align: center;
    }

    &__kpi-name {
      font-size: 16px;
      font-weight: 400;
      color: #000;
      text-align: center;
    }

    &__header {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: 10;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 16px;
      pointer-events: none;
    }

    &__header-right {
      display: flex;
      align-items: center;
      gap: 12px;
      pointer-events: auto;
    }

    &__close {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      background: rgba(0, 0, 0, 0.5);
      border: none;
      border-radius: 50%;
      cursor: pointer;
      transition: background 200ms ease;

      &:hover {
        background: rgba(0, 0, 0, 0.8);
      }
    }

    &__iframe-container {
      overflow: hidden;
      width: 100%;
      padding-top: 56.25%; // 16:9
      position: relative;
    }

    &__video {
      border: 0;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }

  @media (max-width: 767px) {
    .live-modal {
      width: 90%;
      height: 75vh;

      &__kpi-bar {
        top: 65px;
        bottom: auto;
        left: 50%;
        transform: translateX(-50%);
        gap: 16px 28px;
        padding: 16px 22px;
        border-radius: 12px;
        width: auto;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: 1fr 1fr;
        justify-items: start;
      }

      &__kpi-item {
        flex-direction: row;
        gap: 10px;

        img {
          width: 42px;
          height: 42px;
        }
      }

      &__kpi-data {
        align-items: flex-start;
      }

      &__kpi-value {
        font-size: 20px;
        white-space: nowrap;
      }

      &__kpi-name {
        font-size: 14px;
      }

      &__iframe-container {
        padding-top: 0;
        height: 100%;
      }

      &__video {
        height: 75vh;
        width: calc(75vh * 16 / 9);
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LiveMeteoModal.vue